import gql from "graphql-tag";
import { FRAGMENT_NEIGHBORHOOD_ORGANISMS } from "./fragments.js";

export const GET_NEIGHBORHOOD_ORGANISMS = gql`
  ${FRAGMENT_NEIGHBORHOOD_ORGANISMS}
  query GetNeighborhoodOrganisms($uri: String!) {
    organisms: nodeByUri(uri: $uri) {
      ...OrganismsFragment
    }
  }
`;